module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/legend.fb95fd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/legend.jpg
// module id = F2Ku
// module chunks = 0